import { amslerGridInstruction } from "@constants/instructionConstants";
import {
  AvailablePreTestConfigurationOptions,
  TestType,
  EyeType,
  TestConfiguration,
  TestCategory,
  WaitDuration,
  TestUIConfiguration,
} from "types/testTypes";
import { AVAILABLE_EYE_OPTIONS_BINOCULAR_MONOCULAR } from "../configurationHelperConstants";
import {
  CATEGORY_VERSION_MAP,
  FEATURE_VERSION_MAP,
  TEST_TYPE_VERSION_MAP,
} from "../versionConstants";

export const availableAmslerGridTestConfigurationOptions: AvailablePreTestConfigurationOptions = {
  testTypes: {
    configurationFieldName: "testType",
    validSinceVersion: CATEGORY_VERSION_MAP[TestCategory.AmslerGrid],
    choices: [{ validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.Chart], value: TestType.Chart }],
    isMandatory: true,
  },
  eyeConfigurationOptions: {
    ...{
      ...AVAILABLE_EYE_OPTIONS_BINOCULAR_MONOCULAR,
      eyeTypes: {
        ...AVAILABLE_EYE_OPTIONS_BINOCULAR_MONOCULAR.eyeTypes,
        choices: [
          { validSinceVersion: null, value: EyeType.BothEye },
          {
            validSinceVersion: FEATURE_VERSION_MAP.amslerGridSingleEyeTestSupport,
            value: EyeType.RightEye,
          },
          {
            validSinceVersion: FEATURE_VERSION_MAP.amslerGridSingleEyeTestSupport,
            value: EyeType.LeftEye,
          },
        ],
      },
    },
  },
  languageOptions: null,
  virtualAssistantOptions: null,
  testSpeedOptions: null,
};

export const amslerGridTestConfiguration: TestConfiguration = {
  name: TestCategory.AmslerGrid,
  testType: TestType.Chart,
  eyeConfiguration: {
    eyeType: EyeType.BothEye,
    isCalibrationNeeded: false,
    autoPauseForGaze: false,
    isTwoScreenFixationEnabled: true,
    isBackToBackEyeTest: false,
  },
  testSpeed: WaitDuration.Standard,
  testLanguage: null,
  virtualAssistanceConfig: null,
  isPressToStartEnabled: false,
};

export const amslerGridUIConfiguration: TestUIConfiguration = {
  showProgressBar: false,
  instructions: amslerGridInstruction,
};
